<mat-card>
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
      <h2 fxFlex>{{ cardTitle }}</h2>
      <div fxFlex class="right">
        <button mat-mini-fab (click)="editClicked()" [matTooltip]="'Edit ' + cardTitle">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>

    <nuso-properties-table
      [fields]="fields"
      [data]="data"
    ></nuso-properties-table>
  </mat-card-content>
</mat-card>
